module.exports = __webpack_public_path__ + "d3e17dc0ecd3e5122a0d504e7b1ec3f9.svg";